import { useQuery } from '@tanstack/react-query';
import { api, GrTrackedTimeGame } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseTimeGamesReturn {
  games: GrTrackedTimeGame[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

/** Games that have tracked time — options for the Time / Rewards metric views. */
export function useTimeGames(): UseTimeGamesReturn {
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: queryKeys.gameRewards.timeGames(),
    queryFn: () => api.getGameRewardsTimeGames(),
  });

  return {
    games: data?.games ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : isError ? 'Failed to load games' : null,
    refresh: () => {
      refetch();
    },
  };
}
